import { notification, Button } from "antd";
import React from "react";

const notification_arr = [];
const duration = 8;
const maxCount = 4;

global.notification = (localStorage.getItem("notification") || "true") === "true";
global.notifyDuration = +(localStorage.getItem("notifyDuration") || 10);

notification.config({
    maxCount: maxCount,
    placement: "bottomRight",
});

const openNotificationWithIcon = (type, message, description, time = new Date().toTimeString().split(" ")[0]) => {
    if (global.notification !== true) {
        while (notification_arr.length > 0) {
            notification_arr.map(k => notification.close(k));
            notification.destroy();
            notification_arr.shift();
        }
        return;
    }

    if (description) {
        description = typeof description === "string" ? description : JSON.stringify(description);
    }

    const key = Math.random().toString();

    notification_arr.push(key);
    while (notification_arr.length > maxCount) {
        notification_arr.shift();
    }
    if (notification_arr.length === maxCount) {
        notification.close(notification_arr[0]);
    }

    const onClick = () => {
        notification.close(key);
    };

    let new_close_icon = React.createElement("div", {}, " ");
    // let new_close_icon = new Date().toLocaleTimeString()
    let button = (<Button size={"small"}>{time}</Button>);

    let dur = duration;
    if (type === false) {
        dur = 10;
    }
    else if (type === "info") {
        dur = +global.notifyDuration;

        if (description.split("\r\n").length === 2) {
            button = (<Button style={{ marginTop: "26%" }}>{time}</Button>);
            // $('.ant-notification-notice-btn').css('margin-top', '-18%');
        }
        else if (description.split("\r\n").length === 3) {
            // $('.ant-notification-notice-btn').css('margin-top', '-23.2%');
        }
    }

    if (type === true) {
        notification.success({
            message: message || "Success",
            description: description || "",
            duration: dur,
            key: key,
            onClick: onClick,
        });
    }
    else if (type === "info") {
        notification.info({
            message: message || "Info",
            description: description || "",
            duration: dur,
            key: key,
            onClick: onClick,
            btn: button,
            closeIcon: new_close_icon,
        });
    }
    else if (type === "warning") {
        notification.warning({
            message: message || "Warning",
            description: description || "",
            duration: dur,
            key: key,
            onClick: onClick,
        });
    }
    else {
        notification.error({
            message: message || "Error",
            description: description || "",
            duration: dur,
            key: key,
            onClick: onClick,
        });
    }
};

export default openNotificationWithIcon;



// WEBPACK FOOTER //
// ./src/utils/Tools.js